import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import client from "@culturehq/client";
import { classnames, Panel } from "@culturehq/components";

import { useFetch, useRecognitionCreatedListener } from "app/hooks";
import { Trans } from "app/utils";

import ErrorBoundary from "components/common/ErrorBoundary";
import RecognitionHeader from "components/recognitions/recognition/RecognitionHeader";

const Recognitions = () => {
  const { json: { recognitions = [] }, onUpdate } = useFetch(
    () => client.listRecognitions().then(response => ({
      recognitions: response.recognitions.slice(0, 3)
    }))
  );

  const [animate, setAnimate] = useState(false);

  useRecognitionCreatedListener(
    useCallback(
      recognition => {
        setAnimate(true);
        onUpdate(current => ({
          ...current,
          recognitions: [recognition, ...current.recognitions]
        }));

        setTimeout(
          () => {
            setAnimate(false);
            onUpdate(current => ({
              ...current,
              recognitions: current.recognitions.slice(0, 3)
            }));
          },
          400
        );
      },
      [onUpdate]
    )
  );

  const className = classnames("recognitions", "SidePanel", {
    "recognitions-animate": animate
  });

  return (
    <Panel className={className}>
      <Panel.Heading>
        <Trans>Latest Recognitions</Trans>
      </Panel.Heading>
      <Panel.Body className="no-padding">
        <ErrorBoundary>
          {recognitions.map(recognition => (
            <div key={recognition.id} className="recognitions__recognition-summary">
              <RecognitionHeader recognition={recognition} />
            </div>
          ))}
        </ErrorBoundary>
      </Panel.Body>
      <Panel.Footer>
        <Link to="/recognitions" className="all link nowrap">
          <Trans>View all</Trans>
        </Link>
      </Panel.Footer>
    </Panel>
  );
};

export default Recognitions;
